module.exports = __webpack_public_path__ + "img/a5.46975e19.jpg";